function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavDashboard = function SvgNavDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M79.17 0H12.5C5.61 0 0 5.61 0 12.5v41.67c0 6.89 5.61 12.5 12.5 12.5h66.67c6.89 0 12.5-5.61 12.5-12.5V12.5c0-6.89-5.61-12.5-12.5-12.5m4.16 54.17c0 2.3-1.88 4.17-4.17 4.17H12.5a4.18 4.18 0 0 1-4.17-4.17V12.5c0-2.3 1.88-4.17 4.17-4.17h66.67a4.18 4.18 0 0 1 4.17 4.17v41.67ZM79.17 83.33H12.5C5.61 83.33 0 88.94 0 95.83v91.67c0 6.89 5.61 12.5 12.5 12.5h66.67c6.89 0 12.5-5.61 12.5-12.5V95.83c0-6.89-5.61-12.5-12.5-12.5m4.16 104.17c0 2.3-1.88 4.17-4.17 4.17H12.5a4.18 4.18 0 0 1-4.17-4.17V95.83c0-2.3 1.88-4.17 4.17-4.17h66.67a4.18 4.18 0 0 1 4.17 4.17v91.67ZM187.5 133.33h-66.67c-6.89 0-12.5 5.61-12.5 12.5v41.67c0 6.89 5.61 12.5 12.5 12.5h66.67c6.89 0 12.5-5.61 12.5-12.5v-41.67c0-6.89-5.61-12.5-12.5-12.5m4.17 54.17c0 2.3-1.88 4.17-4.17 4.17h-66.67a4.18 4.18 0 0 1-4.17-4.17v-41.67c0-2.3 1.88-4.17 4.17-4.17h66.67a4.18 4.18 0 0 1 4.17 4.17z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 91.67,
    height: 116.67,
    x: 108.33,
    rx: 12.5,
    ry: 12.5,
    style: {
      fill: "#e3f9ff",
      strokeWidth: 0
    }
  }));
};
export default SvgNavDashboard;